module.exports = __webpack_public_path__ + "img/CQC.411d547c.jpg";